/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadyitemphone3Inputs */

const en_searchreadyitemphone3 = /** @type {(inputs: Searchreadyitemphone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone number`)
};

const de_searchreadyitemphone3 = /** @type {(inputs: Searchreadyitemphone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonnummer`)
};

/**
* | output |
* | --- |
* | "Phone number" |
*
* @param {Searchreadyitemphone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadyitemphone3 = /** @type {((inputs?: Searchreadyitemphone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadyitemphone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadyitemphone3(inputs)
	return de_searchreadyitemphone3(inputs)
});
export { searchreadyitemphone3 as "searchReadyItemPhone" }